import helper from './helper'

$(document).on('click', '.js-open-lightbox', event => {
    const $trigger = $(event.currentTarget)
    const $lightBox = $(
        '<div class="grid-container lightbox-wrapper">' +
            '<div class="grid-x grid-margin-x">' +
            '<div class="cell desktop-6 image-holder mb24 medium-mb32 desktop-mb0">' +
            `<img src="${$trigger.data('img-1')}" srcset="${$trigger.data(
                'img-1'
            )},
            ${$trigger.data('img-2')} 2x" alt="">` +
            '</div>' +
            '<div class="cell desktop-6 text-holder">' +
            '<h4 class="mb8 desktop-mb16">' +
            $trigger.data('date') +
            '</h4>' +
            '<h3 class="mb16">' +
            $trigger.data('title') +
            '</h3>' +
            '<div class="p-80">' +
            $trigger.data('modal-text') +
            '</div>' +
            '</div>' +
            '</div>'
    )
    $('.js-popup-content', helper.$modal).html($lightBox)
    helper.$modal.foundation('open')
})
